import React, { useState } from 'react';
import CategoryEditModal from '../components/AdminCategoriesPage/CategoryEditModal';
import CategoryAddModal from '../components/AdminCategoriesPage/CategoryAddModal';
import CategoryDeleteModal from '../components/AdminCategoriesPage/CategoryDeleteModal';
import SearchFilter from '../components/SearchFilter/SearchFilter';
import CategoriesTable from '../components/AdminCategoriesPage/CategoriesTable';
import CategoriesBulkActions from '../components/AdminCategoriesPage/CategoriesBulkActions';
import useCategoryActions from '../hooks/AdminCategoriesPage/useCategoryActions';

const AdminCategoriesPage = () => {
  const [editCategory, setEditCategory] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(null);

  const {
    filteredCategories,
    selectedCategories,
    clearSelectedCategories,
    loadCategories,
    handleFilter,
    handleSelectAll,
    handleCategorySelect
  } = useCategoryActions();

  return (
    <div className="admin-page">
      <div className="admin-page__intro">
        <h1>Categories</h1>
      </div>

      <div className="admin-page__content">
        <div className="admin-page__tools">
          <SearchFilter onFilter={handleFilter} />
          <CategoriesBulkActions
            selectedCategories={selectedCategories}
            clearSelectedCategories={clearSelectedCategories}
            loadCategories={loadCategories}
          />
          <div className="admin-page__tools_buttons">
            <button className="button primary" onClick={() => setIsAddModalOpen(true)}>
              Add Category
            </button>
          </div>
        </div>

        <CategoriesTable
          categories={filteredCategories}
          onEdit={setEditCategory}
          onDelete={setDeleteCategory}
          onCategorySelect={handleCategorySelect}
          selectedCategories={selectedCategories}
          onSelectAll={handleSelectAll}
        />
        <div className="admin-page__footer">
          <p>Categories count: {filteredCategories.length}</p>
        </div>
      </div>

      <CategoryEditModal
        isOpen={!!editCategory}
        onClose={() => setEditCategory(null)}
        onSuccess={() => {
          loadCategories();
          setEditCategory(null);
        }}
        category={editCategory}
      />

      <CategoryAddModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={() => loadCategories()}
      />

      <CategoryDeleteModal
        isOpen={!!deleteCategory}
        onClose={() => setDeleteCategory(null)}
        onSuccess={() => {
          loadCategories();
          setDeleteCategory(null);
        }}
        category={deleteCategory}
      />
    </div>
  );
};

export default AdminCategoriesPage;